module.exports = __webpack_public_path__ + "img/arw-anchor-left.151165f0.svg";